import React, { Component } from 'react'
import styled from 'styled-components'
import { backgroundColors } from 'config'

export default class ButtonGradientV2 extends Component {
  handleClick = (e) => {
    const { onClick, setModalTriggerHeight } = this.props

    onClick && onClick(e)
    if (setModalTriggerHeight) {
      setModalTriggerHeight(this.buttonRef.getBoundingClientRect().top)
    }
  }

  render() {
    const {
      icon,
      trailingIcon,
      children,
      className,
      danger,
      ...restProps
    } = this.props

    return (
      <Wrapper
        innerRef={(ref) => (this.buttonRef = ref)}
        danger={danger}
        bgColor={
          danger
            ? 'linear-gradient(270deg, #5A0000 -58.87%, #C00000 100%)'
            : backgroundColors.normalLeft
        }
        className={className}
        {...restProps}
        onClick={this.handleClick}>
        {icon}
        {children}
        {trailingIcon}
      </Wrapper>
    )
  }
}
const Wrapper = styled.button.attrs({ ref: (props) => props.buttonRef })`
  display: flex;
  height: 40px;
  padding: 8px;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  border: none;
  background: ${({ bgColor }) => bgColor};

  cursor: pointer;

  color: #fff;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;

  > svg,
  path {
    fill: #fff;
  }

  &:hover {
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.2) 0%,
        rgba(0, 0, 0, 0.2) 100%
      ),
      linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);

    ${({ danger }) =>
      danger &&
      `
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), linear-gradient(270deg, #5A0000 -58.87%, #C00000 100%);
    `}
  }

  &:disabled {
    background: #ececec;
    cursor: default;
    pointer-events: none;
    color: #bababa;
  }
`



// WEBPACK FOOTER //
// ./src/components/ButtonGradientV2/index.js